import { InstaImage, InstaProfileINT } from "../../src/components/insta/interfaces";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { store } from "../../src/store/store";
import { ann } from "../characters/Ann";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { extras } from "../story/images";
import { annImages, annProfilesPic } from "./annInstaImages";
import { getInstaProfile, getImagePost, random, isAnnHate, isAnnGF, setMinLikes } from "./helpers";

export const annConditions: { [key: number]: { condition: (() => boolean), order?: number; }; } = {
    1: { condition: () => isAnnHate() || mc.properties.annLateGF },
    2: { condition: () => isAnnHate() || mc.properties.annLateGF },
    3: { condition: () => isAnnHate() },
    4: { condition: () => mc.properties.annLateGF && ann.properties.isCorrupted },
    5: { condition: () => mc.properties.annLateGF && ann.properties.isCorrupted },
    6: { condition: () => isAnnHate() },
    7: { condition: () => (mc.properties.annLateGF || isAnnGF()) && ann.properties.isCorrupted },
    8: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann8") },
    9: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann8") },
    10: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann9") },
    11: { condition: () => false },
    12: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann12") },
    13: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann13") },
    14: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann14") },
    15: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann15") },
    16: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann16") },
    17: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann17") },
    18: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann18") },
    19: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann19") },
    20: { condition: () => !!ann.properties.v7PhotoShootPhotosMCPicked.concat(ann.properties.v7PhotoShootPhotosANNPicked).find(pic => ImageClass._globalImages.get(pic)?.key === "Ann20") },
    21: { condition: () => isAnnHate() },
    22: { condition: () => isAnnHate() },
    23: { condition: () => isAnnGF() && ann.properties.isCorrupted },
    24: { condition: () => isAnnGF() && ann.properties.isCorrupted },
    25: { condition: () => isAnnGF() && ann.properties.isCorrupted, order: 26 },
    26: { condition: () => isAnnGF() && ann.properties.isCorrupted, order: 25 },
    27: { condition: () => isAnnHate() },
    28: { condition: () => (Question.globalAnswers.V8AnnDateMCOkWithChris) || isAnnHate() },
};

const currentOrNotIncludedScene = (scene: string) => {
    return Game.currentScene === scene && !Game.seenScenarios.includes(scene);
};

function annImagesStoryLogic(image: InstaImage, index: number) {


    //  add array in the empty char, of likes [1,2,3,4,5] and add them to this object and reset it after you do (don't forget that here the index is +1)

    if (Game.currentScene === 'RoomAfterEventsBTNS') {
        if (index > 1) { return false; }
        image.likes = 1;
    }
    if (Game.currentScene === 'ClubEventInstaCheck') {
        if (index > 2) { return false; }
        image.likes = setMinLikes(image.likes, 3, 15);

    }
    if (Game.currentScene === 'AfterClubEndDay' || Game.currentScene === 'homeCheckInsta') {
        if (index > 3) { return false; }
        image.likes = setMinLikes(image.likes, 3, 15);

    }

    if (Game.currentScene === 'V5HomeAfterVanessaHome' || Game.currentScene === 'V5AfterBeachJoeyOrEmilyAloneNoEvents') {
        if (index > 5) { return false; }
        image.likes = setMinLikes(image.likes, 13, 20);

    }


    if (
        Game.currentScene === 'V5HomeAfterVanessaAnn' ||
        Game.currentScene === 'V5EndDay2' ||
        Game.currentScene === "V6EmilysRoomQuestion" ||
        Game.currentScene === "V6HomeRecap"
    ) {
        image.likes = setMinLikes(image.likes, 13, 20);
        if (index > 21) { return false; }

        if (currentOrNotIncludedScene(`V6EmilysRoomQuestion`)) {
            if (index === 21) {
                image.likes = setMinLikes(image.likes, 300, 1000);
            }
        }
    }

    if (Game.currentScene === "V6EndDay") {
        if (index > 22) { return false; }

        if (mc.properties.annStatus === "hate") {
            image.likes = setMinLikes(image.likes, 500, 5000);
        } else {

            if (currentOrNotIncludedScene(`V6EndDay`)) {

                image.likes += random(1, 100);
            }
        }
    }
    if (Game.currentScene === `V7MCRoomWait`) {
        image.likes = setMinLikes(image.likes, 50, 200);

        if (currentOrNotIncludedScene(`V7MCRoomWait`)) {
            image.likes += random(50, 200);
        }
        if (index > 22) {
            return false;
        }
    }
    if (Game.currentScene === `V7MCRoomWait2`) {
        image.likes = setMinLikes(image.likes, 50, 200);

        if (currentOrNotIncludedScene(`V7MCRoomWait2`)) {
            image.likes += random(50, 200);
        }
        if (index > 24) {
            return false;
        }
    }
    if (Game.currentScene === `V7EndDay`) {
        image.likes = setMinLikes(image.likes, 100, 1000);

        if (currentOrNotIncludedScene(`V7EndDay`)) {
            image.likes += random(100, 1000);
        }
        if (index > 24) {
            return false;
        }
    }
    if (Game.currentScene === `V8MCRoomMorning`) {

        image.likes = setMinLikes(image.likes, 500, 5000);

        if (index > 27) {
            return false;
        }
    }
    if (Game.currentScene === `V8EndDay1`) {

        image.likes = setMinLikes(image.likes, 2000, 5000);

        if (index > 27) {
            return false;
        }
    }
    if (Game.currentScene === `V9Events`) {

        image.likes = setMinLikes(image.likes, 1000, 5000);

        if (index > 28) {
            return false;
        }
    }

    const num = image.key.split(ann.key)[1];
    if (Object.keys(annConditions).includes((num))) {
        const order = Object.keys(annConditions).indexOf((num)) + 1;

        image.order = annConditions[Number(num)].order || order;

        return annConditions[Number(num)].condition();
    }
    return false;
}
export function AnnProfilePictureLogic(): TimageINT & { key?: string; } {
    if (Game.seenScenarios.includes(`V7MCRoomWait`)) {
        if (isAnnGF() && ann.properties.isCorrupted) {
            ann.set((properties) => {
                properties.instaProfileImage = annProfilesPic.annInstaPortrait4;
            });
            return annProfilesPic.annInstaPortrait4;
        }
    } else if (Game.seenScenarios.includes(`ClubEventInstaCheck`) || Game.seenScenarios.includes(`AfterClubEndDay`)) {
        ann.set((properties) => {
            properties.instaProfileImage = annProfilesPic.annInstaPortrait2;
        });
        return annProfilesPic.annInstaPortrait2;
    } else if (Game.seenScenarios.includes(`V6EmilysRoomQuestion`)) {
        if (mc.properties.annStatus === "hate") {
            ann.set((properties) => {
                properties.instaProfileImage = annProfilesPic.annInstaPortrait3;
            });
            return annProfilesPic.annInstaPortrait3;
        }
    }



    return ann.properties.instaProfileImage;
}
function annProfileStoryLogic(): Partial<InstaProfileINT> {
    const profiles = store.getState().insta.present.profiles;

    return {
        description: ann.properties.instaDescription,
        followers: ann.properties.instaFollowers,
        following: ann.properties.instaFollowing,
        instaProfileImage: AnnProfilePictureLogic(),
    };
}

export const annInstaPhotos = (): InstaProfileINT => {

    return {
        ...getInstaProfile(ann, annProfileStoryLogic()),

        images: [
            ...Object.keys(annImages).map((image, index) => getAnnImagesPost(index + 1)),

        ].filter((image, index) => annImagesStoryLogic(image, index + 1)).reverse().sort((a: InstaImage, b: InstaImage) => (a.order || 0) > (b.order || 0) ? -1 : 1)
    } as InstaProfileINT;

};





const getAnnImagesPost = (id: number, options?: Partial<InstaImage>) => (getImagePost(annImages, store.getState().insta.present?.profiles?.[ann.key], `${ann.key}${id}`, options));